/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { ListingAttachmentResponseDto } from './listingAttachmentResponseDto';
import type { ListingDetailResponseDto } from './listingDetailResponseDto';
import type { ListingLocationItemResponseDto } from './listingLocationItemResponseDto';
import type { ListingPhotoResponseDto } from './listingPhotoResponseDto';
import type { ListingResponseDtoCurrencyCode } from './listingResponseDtoCurrencyCode';
import type { ListingResponseDtoPriceType } from './listingResponseDtoPriceType';
import type { ListingResponseDtoPropertyCategory } from './listingResponseDtoPropertyCategory';
import type { ListingResponseDtoType } from './listingResponseDtoType';
import type { ListingResponseDtoVisibilityStatus } from './listingResponseDtoVisibilityStatus';
import type { ListingSellerContactResponseDto } from './listingSellerContactResponseDto';

export interface ListingResponseDto {
  id: string;
  slug: string;
  description: string;
  type: ListingResponseDtoType;
  currencyCode: ListingResponseDtoCurrencyCode;
  propertyCategory: ListingResponseDtoPropertyCategory;
  /** @nullable */
  finalPrice: number | null;
  /** @nullable */
  priceType: ListingResponseDtoPriceType;
  priceOnRequest: boolean;
  visibilityStatus: ListingResponseDtoVisibilityStatus;
  state: ListingLocationItemResponseDto;
  /** @nullable */
  region: ListingLocationItemResponseDto | null;
  /** @nullable */
  district: ListingLocationItemResponseDto | null;
  /** @nullable */
  municipality: ListingLocationItemResponseDto | null;
  /** @nullable */
  street: string | null;
  createdAt: string;
  /** @nullable */
  createdByUserId: string | null;
  /** @nullable */
  latitude: number | null;
  /** @nullable */
  longitude: number | null;
  /** @nullable */
  photo: ListingPhotoResponseDto | null;
  /** @nullable */
  detail: ListingDetailResponseDto | null;
  /** @nullable */
  primaryVideoUrl: string | null;
  /** @nullable */
  virtualTourUrl: string | null;
  /** @nullable */
  floorPlanEmbedUrl: string | null;
  gallery?: ListingAttachmentResponseDto[];
  sellerContact: ListingSellerContactResponseDto;
}
